import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeMustNotContain } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationMustNotContain: RelationRuleValidator<
	RuleResourceTypeMustNotContain<RuleGuestAttributeResourceTypeRelation>
> = {
	validate: (rule, value) => {
		if (value == null) {
			return true;
		}

		switch (rule.guestAttribute.entityType) {
			case "tenant":
			case "tags":
			case "guestType":
			case "groups":
			case "region":
			case "wave": {
				const ruleArray = Array.isArray(rule.value) ? rule.value : [rule.value];
				const valueArray = Array.isArray(value) ? value : [value];

				return !ruleArray.every((x) => valueArray.includes(x));
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
